import axios from 'axios'
import router from '../../router' // Lecture 364

const state = {
  userToken: null,
  userId: null,
  team: null,
  userProfile: null,
  coach: false,

  aakashId: null,
};

const mutations = {
  authUser (state, userData) {
    console.log('Storing Authentication Data')
    state.userToken = userData.token
    state.userId = userData.user_id
    // state.team = userData.team
    // state.coach = userData.coach
  },
  storeUser (state, userData) {
    state.userProfile = userData
  },
  clearAuthData (state) {
    state.userToken = null
    state.userProfile = null
    state.team = null
    state.coach = false
    // router.replace('/')
  }
};

const actions = {
  tryAutoLogin ({commit}) { // Lecture 366
    console.log('Trying auto log in')
    const stored_token = localStorage.getItem('token')
    if (!stored_token) {
      console.log('No Token')
      return
    }
    // const expirationDate = localStorage.getItem('expirationDate')
    // const now = new Date()
    // if (now >= expirationDate) {
    //   return
    // }
    const stored_user_id = localStorage.getItem('user_id')
    // const stored_team = localStorage.getItem('team')
    // const stored_coach = localStorage.getItem('coach')
    commit('authUser', {
      token: stored_token,
      user_id: stored_user_id,
      // team: stored_team,
      // coach: stored_coach,
    })
  },
  // registerCandidate ({commit, dispatch}, authData) {
  //   // https://vuex.vuejs.org/guide/actions.html
  //   // https://stackoverflow.com/questions/45848974/call-an-action-from-within-another-action
  //   return new Promise((resolve, reject) => {
  //     axios.post('/optimum/create-candidate/', {
  //       email: authData.email,
  //       password: authData.password,
  //       agency: 2, // The DameUnaMano Agency object has an id of 2
  //     })
  //       .then(res => {
  //         console.log(res)
  //         // this.testAction
  //         resolve()
  //         dispatch('login', authData) // Lecture 360
  //         // axios.post('/optimum/create-dameunamano-user/')
  //       })
  //       .catch(error => console.log(error))
  //   })
  // },
  registerUser ({commit, dispatch}, authData) {
    // https://vuex.vuejs.org/guide/actions.html
    // https://stackoverflow.com/questions/45848974/call-an-action-from-within-another-action
    return new Promise((resolve, reject) => {
      // axios.post('/api/users/', {
      axios.post('/user-registration/', {
        email: authData.email,
        password: authData.password,
        // agency: 'DameUnaMano', // The DameUnaMano Agency object has an id of 2
        // user_type: authData.user_type,
        // team: authData.team,
      })
        .then(res => {
          console.log(res)
          // this.testAction
          resolve()
          dispatch('login', authData) // Lecture 360
          // axios.post('/optimum/create-dameunamano-user/')
        })
        .catch(error => console.log(error))
    })
  },
  login ({commit, dispatch}, authData) {
    // https://vuex.vuejs.org/guide/actions.html
    // https://stackoverflow.com/questions/45848974/call-an-action-from-within-another-action
    return new Promise((resolve, reject) => {
      axios.post('/api-token-auth/', {
        username: authData.email,
        password: authData.password,
      })
        .then(res => {
          console.log(res)
          commit('authUser', {
            token: res.data.token,
            user_id: res.data.user_id,
            // team: res.data.team,
            // coach: res.data.coach,
          })
          // Need to save both of these for the authUser mutation
          localStorage.setItem('token', res.data.token) // Lecture 366
          localStorage.setItem('user_id', res.data.user_id)
          // localStorage.setItem('team', res.data.team)
          // localStorage.setItem('coach', res.data.coach)

          // const now = new Date()
          // const expirationDate = new Date(now.getTime() + 3600000) // Covert the date to milliseconds, add an hour, then convert back to a date
          // localStorage.setItem('expirationDate', expirationDate)
          resolve()
          // dispatch('getUser') // Once someone logs in get their user profile, update: don't need to, can just call getUser from the user profile component
          // dispatch('setLogoutTimer') // If we want to auto log people out - Lecture 365, this is less relevant since the DRF token doesn't have an expiration
          // if (res.data.is_candidate) {
          //   router.replace('/proveedore')
          // }
          // if (res.data.is_employer) {
          //   router.replace('/enfermeras-cotizar')
          // }

          // if (res.data.coach) {
          //   router.replace('/coachdashboard')
          // }
          // else {
          //   router.replace('/dashboard')
          // }
          router.replace('/dashboard')
        })
        // Problem logging in, likely incorrect email or password, or account doesn't exist
        .catch(error => {
          console.log(error)
          reject() // https://forum.vuejs.org/t/resolving-promises/1007
        })
    })
  },
  logout ({commit}) {
    // router.replace('/')
    commit('clearAuthData')
    // router.replace('/login') // After someone logs out send them to the login page - Lecture 364
    // When someone logs out we want to clear their auth details from the browser, so they have to log back in - Lecture 366
    // localStorage.removeItem('expirationDate')
    localStorage.removeItem('token')
    localStorage.removeItem('user_id')
    // localStorage.removeItem('team')
    // localStorage.removeItem('coach')

    // router.replace('/')
  },
  getUser ({commit, state}) {
    // https://vuex.vuejs.org/guide/actions.html
    // https://stackoverflow.com/questions/45848974/call-an-action-from-within-another-action
    return new Promise((resolve, reject) => {
      if (!state.userToken) { // If someone is not authenticated - Lecture 361
        console.log('Not Authenticated')
        return
      }
      console.log(state.userId)
      let api_url = '/api/users/?id='.concat(state.userId.toString()) // Right now there is no authentication on this get request, need to add that later
      axios.get(api_url)
        .then(res => {
          console.log('Retrieved user data, here it is:')
          console.log(res.data[0]) // The get request gets an array of users back with one user (with the specific id we requested)
          commit('storeUser', {
            userData: res.data[0]
          })
          resolve()
        })
    })
  },
  setLogoutTimer ({commit, dispatch}, expirationTime) { // Auto logging out user after some time - Lecture 365
    setTimeout(() => {
      // commit('clearAuthData') // After time is up, log user out
      dispatch('logout')
    }, 3600000) // One hour in milliseconds
  }
};

const getters = {
  user (state) {
    // console.log(state.userProfile.userData)
    if (state.userProfile && state.userProfile.userData) {
      return state.userProfile.userData
    }
    return null
  },
  userID (state) {
    return state.userId
  },
  isAuthenticated (state) {
    return state.userToken !== null
  },
  userAPIURL (state) {
    return '/api/users/'.concat(state.userId.toString()).concat('/')
  },
  team (state) {
    return state.team
  },
  isCoach (state) {
    if (state.coach == 'true') {
      return true
    }
    else {
      return false
    }
    // return state.coach
  },
  userToken (state) {
    return state.token
  }
};

export default {
  state,
  mutations,
  actions,
  getters,
}



// WEBPACK FOOTER //
// ./src/store/modules/authentication.js